<!--
  疑似棄用，目前使用的是themes\frontend\src\modules\home\showcase2020\index.vue
  首頁特色機種元件
  裡頭又使用了兩個元件，一個是Header；另一個是Motor
  元件說明：Header選單(pc & md選單)元件在：themes/frontend/src/modules/home/_header.vue。v-slot會覆蓋slot標籤的內容
  元件說明：Motor特色機種清單元件內版型在：ShowcaseMotor.vue
-->
<template>
  <div id="showcase" class="showcase">
    <!-- <div class="container container--header"> -->
    <Header class="sticky motorMenuBox">
      <template #submenuseries>
        <!-- pc尺寸時會出現 -->

        <div class="motorMenu category">
          <template>
            <div class="tabs">
              <div class="item" style="letter-spacing: 8px" @click="changeCategory('series')">
                <img src="@/assets/site/icon-arrowRight.png" alt="" />
                <span>排氣量</span>
              </div>
            </div>
          </template>
          <div class="navigation">
            <template v-for="{ name, motors } in series">
              <div
                v-if="motors.length !== 0"
                :key="name"
                :class="{ active_major: current.category == name, long: name == '微型電動二輪車' }"
                class="item"
                @click="checkCategoryUrl('series', name)"
                @mouseenter="mouseenter"
                @mouseleave="mouseleave">
                <div class="item-inner"></div>
                <span>{{ name }}</span>
              </div>
            </template>
            <div class="item" @mouseenter="mouseenter" @mouseleave="mouseleave">
              <div class="item-inner"></div>
              <a href="https://www.kymco.com.tw/mobilityscooter/" target="_blank">代步車</a>
            </div>
          </div>
          <hr />
        </div>
      </template>

      <template #submenustyles>
        <div class="motorMenu styles" v-if="enableStyleFilter">
          <template>
            <div class="tabs">
              <div class="item" @click="changeCategory('styles')">
                <img src="@/assets/site/icon-arrowRight_blue.png" alt="" />
                <span>生活型態</span>
              </div>
            </div>
          </template>
          <div class="navigation">
            <template v-for="{ name, motors } in styles">
              <div
                v-if="motors.length !== 0"
                :key="name"
                :class="{ active_dark: current.category == name }"
                class="item"
                @click="checkCategoryUrl('styles', name)"
                @mouseenter="mouseenter"
                @mouseleave="mouseleave">
                <div class="item-inner"></div>
                <span>{{ name }}</span>
              </div>
            </template>
          </div>
        </div>
      </template>
    </Header>

    <!-- </div> -->

    <!-- md尺寸時會出現 -->
    <div ref="sticky" class="sticky-mobile-category">
      <div v-viewport-condition="'< md'" class="container">
        <div class="mobile-category">
          <div class="motorMenuToggleBtn" :class="{ 'is-style': current.findBy == 'style' }" @click="toggleSelect">
            {{ current.category == '100-110' ? '100-115' : current.category }}
            <div class="moreBtn">&#10094;</div>
          </div>
          <!-- nav info -->
          <div class="motorMenu-info close">
            <ul>
              <li class="title-capacity">
                <div class="item" data-page="capacity">依排氣量</div>
              </li>
              <template v-for="{ name, motors } in series">
                <li v-if="motors.length !== 0" :key="name" @click.prevent="checkCategoryUrl('capacity', name)">
                  <span :class="{ active: current.category == name }"></span>{{ name }}
                </li>
              </template>
              <li>
                <a href="https://www.kymco.com.tw/mobilityscooter/" target="_blank"> <span></span>代步車 </a>
              </li>

              <li class="title-style" v-if="enableStyleFilter">
                <div class="item" data-page="style">依生活型態</div>
              </li>
              <template v-if="enableStyleFilter">
                <template v-for="{ name, motors } in styles">
                  <li v-if="motors.length !== 0" :key="name" @click.prevent="checkCategoryUrl('style', name)">
                    <span :class="{ active: current.category == name }"></span>{{ name }}
                  </li>
                </template>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- 特色機種清單 -->
    <div class="container">
      <div v-if="displayMotors.length" class="list">
        <div class="pure-g">
          <div class="pure-u-1 pure-u-md-1-2">
            <div class="grid grid--large">
              <Motor :key="motorMainGrid.id" class="motor" :motor="motorMainGrid" :ative="current.category" :data-category="current.category" large />
            </div>
          </div>
          <div class="pure-u-1 pure-u-md-1-2">
            <div class="pure-g">
              <div v-for="motor in motorGrids" :key="motor.id" class="pure-u-1-2">
                <div class="grid">
                  <Motor class="motor" :motor="motor" :ative="current.category" :data-category="current.category" />
                </div>
              </div>
            </div>
          </div>
          <div v-for="motor in motorGridsMore" :key="motor.id" class="pure-u-1-2 pure-u-md-1-4">
            <div class="grid">
              <Motor class="motor" :motor="motor" :ative="current.category" :data-category="current.category" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from './_header.vue'
import Motor from './_motor.vue'
import stableSort from '@/lib/utils/stable'

export default {
  name: 'Showcase',
  components: {
    Header,
    Motor,
  },
  props: {
    styles: Array,
    series: Array,
    enableStyleFilter: Boolean,
  },
  data: function () {
    return {
      menuSeries: ['紅黃牌', '150-250', '125-135', '100-115', '電動車', '微型電動', 'ATV', '代步車'],
      menuStyles: [],
      valueis: this.styles,
      current: {
        findBy: 'series',
        category: '125-135',
        scrollTop: 0,
      },

      prev: {
        category: '125-135',
      },
    }
  },
  computed: {
    categorizedMotors() {
      return [...this.styles, ...this.series].reduce((o, e) => ({ ...o, [e.name]: stableSort(e.motors, this.motorSorter) }), {})
    },
    displayMotors() {
      let categoryName = this.current.category
      return this.categorizedMotors[categoryName]
    },
    motorMainGrid() {
      return this.displayMotors[0]
    },
    motorGrids() {
      if (this.motorMainGrid.showcaseAd) {
        return this.displayMotors.slice(0, 4)
      } else {
        return this.displayMotors.slice(1, 5)
      }
    },
    motorGridsMore() {
      if (this.motorMainGrid.showcaseAd) {
        return this.displayMotors.slice(4)
      } else {
        return this.displayMotors.slice(5)
      }
    },
    currentStyles() {
      return this.foundMotors
        .map((m) => m.styleNames[0])
        .filter((f) => f)
        .filter((el, i, a) => i === a.indexOf(el))
        .slice(0, 3)
    },
    currentCategories(name) {
      const categories_menuSerise = this.menuSeries
      const categories_menuStyles = this.menuStyles
      return { categories_menuSerise, categories_menuStyles }
    },
    nextCategory() {
      const idx = this.currentCategories.indexOf(this.current.category)
      if (this.currentCategories[idx + 1]) {
        return this.currentCategories[idx + 1]
      } else {
        return this.currentCategories[0]
      }
    },
  },
  watch: {},
  mounted() {
    if (typeof window.Stickyfill === 'object') {
      window.Stickyfill.addOne(this.$refs.sticky)
    }

    // 篩選生活型態menu項目，過濾資料長度為0
    this.styles.forEach((item) => {
      if (item.motors.length !== 0) {
        this.menuStyles.push(item.name)
      }
    })

    // init
    $('.motorMenu-info').addClass('close')
  },
  methods: {
    motorSorter(a, b) {
      return (a.showcaseAd === null) - (b.showcaseAd === null)
    },
    checkCategoryUrl(currentFinBY, event) {
      let categoryName = event
      let menuName = event
      if (typeof event === 'string') {
        this.current.category = categoryName
        menuName = event
      } else {
        categoryName = event.currentTarget.value
        menuName = event.currentTarget.value
      }
      this.current.findBy = currentFinBY
      this.current.category = menuName

      const currentCategory = [...this.series, ...this.styles].find((c) => c.name == categoryName)
      if (currentCategory && currentCategory.url) {
        window.open(currentCategory.url)
        this.current.category = this.prev.category
      } else {
        this.prev.category = this.current.category
      }
      $('.motorMenu-info').addClass('close')
      $('html,body').animate({
        scrollTop: ($('#showcase').offset().top)
      }, 1000);

    },
    changeCategory(name) {
      switch (name) {
        case 'series':
          this.current.findBy = 'series'
          this.current.category = this.menuSeries[2]
          break
        case 'styles':
          this.current.findBy = 'styles'
          this.current.category = this.menuStyles[0]
          break
      }
    },
    toggleSelect() {
      // toggle下拉選單
      $('.motorMenu-info').toggleClass('close')
    },
    mouseenter(e) {
      const elmW = $(e.target).width()
      const elmH = $(e.target).height()
      const posX = e.pageX - $(e.target).offset().left
      const posY = e.pageY - $(e.target).offset().top
      e.target.lastChild.style.animationName = 'color'
      if (posX <= elmW * 0.2 && posY <= elmH * 0.2) {
        e.target.firstChild.style.animationName = 'AM_T_E'
      } else if (posX <= elmW * 0.2 && posY >= elmH * 0.7) {
        e.target.firstChild.style.animationName = 'AM_B_E'
      } else if (posX >= elmW * 0.7 && posY >= elmH * 0.7) {
        e.target.firstChild.style.animationName = 'AM_B_E'
      } else if (posX <= elmW * 0.3) {
        e.target.firstChild.style.animationName = 'AM_L_E'
      } else if (posY <= elmH * 0.3) {
        e.target.firstChild.style.animationName = 'AM_T_E'
      } else if (posX >= elmW * 0.7) {
        e.target.firstChild.style.animationName = 'AM_R_E'
      } else if (posY >= elmH * 0.7) {
        e.target.firstChild.style.animationName = 'AM_B_E'
      }
    },
    mouseleave(e) {
      const elmW = $(e.target).width()
      const elmH = $(e.target).height()
      const posX = e.pageX - $(e.target).offset().left
      const posY = e.pageY - $(e.target).offset().top
      e.target.lastChild.style.animationName = 'colorR'
      if (posX <= elmW * 0.2 && posY <= elmH * 0.2) {
        e.target.firstChild.style.animationName = 'AM_T_O'
      } else if (posX <= elmW * 0.2 && posY >= elmH * 0.7) {
        e.target.firstChild.style.animationName = 'AM_B_O'
      } else if (posX >= elmW * 0.7 && posY >= elmH * 0.7) {
        e.target.firstChild.style.animationName = 'AM_B_O'
      } else if (posX <= elmW * 0.3) {
        e.target.firstChild.style.animationName = 'AM_L_O'
      } else if (posY <= elmH * 0.3) {
        e.target.firstChild.style.animationName = 'AM_T_O'
      } else if (posX >= elmW * 0.7) {
        e.target.firstChild.style.animationName = 'AM_R_O'
      } else if (posY >= elmH * 0.7) {
        e.target.firstChild.style.animationName = 'AM_B_O'
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
$colorActive = #27A7E1

line-limit($n = 2)
  overflow hidden
  text-overflow ellipsis
  display -webkit-box
  -webkit-line-clamp $n
  -webkit-box-orient vertical
//整個區塊，選單加商品格
.showcase
  overflow visible !important
  user-select none
  padding-bottom 0px
  @media (min-width 768px)
    padding-top 45px
  @media (max-width 767px)
    padding-bottom 0rem
  .list
    margin-bottom 2rem
    margin-right -1rem
  .motorMenuBox
    // box-shadow -1px 2px 8px 1px rgba(0,0,0,0.10)
    box-sizing content-box
    max-width 1080px
    margin 0 auto
    border-radius 15px
    padding 0
    max-width 1080px
    margin-bottom 1.2em
    width 93%
  .container
    overflow visible

// PC版選單
.motorMenu
  display flex
  align-items center
  flex-wrap wrap
  background-color $gray4
  margin 0em
  position relative
  hr
    position absolute
    z-index 1
    top 90%
    width 95%
    color #fff
    border 0
    border-bottom 1px solid
.motorMenu.category
  border-radius 15px 15px 0 0
  padding 13px 1em 6px
.motorMenu.styles
  border-radius 0px 0px 15px 15px
  padding 6px 1em 15px
// 排氣&生活選單(左)
.tabs
  flex 0 0 18%
  max-width 125px
  font-weight 600
  font-size 1.35rem
  .item
    padding .5em 0
    display inline-block
    padding-left 2.5em
    position relative
    cursor pointer
    img
      position absolute
      top 50%
      left 5px
      transform translateY(-50%)
.category .tabs .item
  color $major
.styles .tabs .item
  color #1EADEF
// 排氣&生活選單(右)
.navigation
  flex 1 0 82%
  display flex
  flex-wrap wrap
  user-select none
  padding 0
  padding-left 0em
  font-size 1.2em
  @media (max-width 900px)
    padding-left 0em
  .item
    position relative
    cursor pointer
    max-width 102px
    flex 0 0 10.5vw
    text-align center
    background-color #fff
    border-radius 25px
    margin 0.25em 4px 0.4em
    overflow hidden
    @media (max-width 900px)
      border-radius 20px
    &.long
      max-width 130px
      flex 0 0 16vw
    span
      position relative
    a,span
      padding 0.25em 0
      color inherit
      position relative
      width 100%
      tpp 0
      line-height 2
      display block
      animation-duration 0.3s
      animation-fill-mode forwards
      font-weight 500
    &.active_dark
      background-color #1EADEF
    &.active_major
      background-color $major
    &.active_dark span ,&.active_major span
      color #fff !important
      font-weight 900
    .item-inner
      width 100%
      height 100%
      position absolute
      top -150%
      left  0
      padding 0.5em 0
      animation-duration 0.5s
      animation-fill-mode forwards
.category .item-inner
  background-color $major
.styles .item-inner
  background-color #1EADEF

// md版的選單
.sticky-mobile-category
  position sticky
  position -webkit-sticky
  top 0px
  z-index 1000
  @media (max-width 767px)
    top 60px
    z-index 999
.mobile-category
  position relative
  padding-top 2rem
  padding-bottom 2rem
  background white
  display flex
  align-items center
  white-space nowrap
  .category
    font-size 2.5rem
  // 下拉選單
  .motorMenu_md
      position sticky
      z-index 1
      width 100%
      top 60px
      background-color #fff
  .motorMenuToggleBtn
    display none
    position relative
    top 0
    left 50%
    width calc(95% - 8vw)
    transform translateX(-50%)
    padding 0.6em 4vw
    font-size 4vw
    font-weight 600
    user-select none
    cursor pointer
    margin-top 0em
    background-color $major
    color #fff
    &.is-style
      background-color #1EADEF
    @media screen and (max-width: 767px)
      display block
  .moreBtn
    transform rotate(-90deg) translateY(240%)
    display inline-block
    position absolute
    color #fff
    right 70px
  .motorMenu-info
    position absolute
    z-index 1
    top 72%
    left 2.3vw
    width 50%
    height 65vh
    border-top 0
    overflow auto
    color #fff
    border-top 1px solid #848484
    ul
      padding 0
      margin 0
      list-style none
      border-top 1px #996666 solid
    li
      position relative
      font-size 3.125vw
      height 8.75vw
      line-height 8.75vw
      font-weight 600
      background-color #616161
      cursor pointer
      padding 0.5em 0 0.5em 2.5em
      border-bottom 1px #848484 solid
      &.none
        display none
      &.title-capacity
        background-color $major
        padding-left 4vw
        color #fff
      &.title-style
        background-color #1EADEF
        padding-left 4vw
        color #fff
      a
        padding 0 0 0 0em
        color #fff
        display block
    span.active
      display block
      position absolute
      left 9.5%
      background-image url('~@/assets/site/motors-icon/tick-icon.png')
      background-size contain
      background-repeat no-repeat
      text-indent -9999px
      top 50%
      left 12.5%
      transform translate(-50%,-50%)
      width 15px
      height 16.6px
      @media $mobile
        width 2.34vw
        height 2.59vw
    &.close
      height 0
      border 0
// schowcase內的格子樣式
// 首頁showcase、機種內頁機種
.pure-g
  .motor
    border-radius 15px
    background-color #f6f6f6
    // box-shadow -2px 2px 5px 2px rgba(0,0,0,0.15);
    margin 1em
    position relative
    padding 0em 1em
    height 30vw
    max-height 330px
    display flex
    text-align center
    align-content center
    flex-wrap wrap
    @media (max-width 767px)
      height 62.5vw
      max-height 400px
  img
    width 100%
.showcase a, .motor  a
  flex 0 0 100%
// 首頁showcase第一格
.grid--large
  .motor
    height 62vw
    max-height 677px
    @media (max-width 767px)
      height 88vw
.list
  .grid
    position relative
    height 100%
    // padding-bottom 25vmin
    border-radius 20px
    margin-right 1rem
    margin-bottom 1rem
    &--large
      width 98%
      height calc(100% - 1rem)
      // margin-bottom 0
    .motor
      position relative
      left 0
      right 0
      bottom 0
      top 0
      margin 0.25em
      padding-top 1.5em
      flex-direction row
      flex-wrap wrap
      box-shadow -1px 2px 8px 1px rgba(0,0,0,0.10)
</style>

<style lang="stylus">
// 排氣&生活選單(右)動態，因為放在<style scoped>動態會失效
.navigation
  .item-inner
    animation-duration 0.5s
    animation-fill-mode forwards
// 動態
@keyframes color
  from
    color #000
  to
    color #fff
@keyframes colorR
  from
    color #fff
  to
    color #000
@keyframes AM_T_E
  from
    top -150%
    left 0%
  to
    top 0%
    left 0%
@keyframes AM_B_E
  from
    top 150%
    left 0%
  to
    top 0%
    left 0%
@keyframes AM_R_E
  from
    top 0%
    left 150%
  to
    top 0%
    left 0%
@keyframes AM_L_E
  from
    top 0%
    left -150%
  to
    top 0%
    left 0%
@keyframes AM_T_O
  from
    top 0%
    left 0%
  to
    top -150%
    left 0%
@keyframes AM_B_O
  from
    top 0%
    left 0%
  to
    top 150%
    left 0%
@keyframes AM_L_O
  from
    top 0%
    left 0%
  to
    top 0%
    left -150%
@keyframes AM_R_O
  from
    top 0%
    left 0%
  to
    top 0%
    left 150%
</style>
